import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  CardHeader,
  Alert
} from 'reactstrap';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import SweetAlert from 'react-bootstrap-sweetalert';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { AvForm, AvField } from 'availity-reactstrap-validation';

class CategoriesComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      selCategory: [],
      alert: null,
      categoryModal: false,
      isEdit: false,
      categoryColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          hidden: true,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'No',
          dataField: 'sortNo',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, cat) => (
            <h5 className='font-size-16 mb-1 '>
              {cat.sortNo}
            </h5>
          )
        },
        {
          text: 'Category (Eng)',
          dataField: 'catName',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, cat) => (
            <h5 className='font-size-16 mb-1 '>
              {cat.catNameLng.catName}
            </h5>
          )
        },
        // {
        //   text: 'Category (Cn)',
        //   dataField: 'catNameCn',
        //   sort: true,
        //   csvExport: false,
        //   hidden: false,
        //   editable: false,
        //   formatter: (cellContent, cat) => (
        //     <h5 className='font-size-16 mb-1 '>
        //       {cat.catNameCn}
        //     </h5>
        //   )
        // },
        // {
        //   text: 'Category (Ru)',
        //   dataField: 'catNameRu',
        //   sort: true,
        //   csvExport: false,
        //   hidden: false,
        //   editable: false,
        //   formatter: (cellContent, cat) => (
        //     <h5 className='font-size-16 mb-1 '>
        //       {cat.catNameRu}
        //     </h5>
        //   )
        // },
        {
          dataField: 'menu',
          text: 'Action',
          editable: false,
          formatter: (cellContent, cntr) => (
            <div className='text-center'>
              <Link className='text-success me-2' to='#'>
                <i
                  className='mdi mdi-pencil font-size-18'
                  id='edittooltip'
                  onClick={(e) => this.handleEditCategory(cntr)}
                ></i>
              </Link>
              <Link className='text-danger' to='#'>
                <i
                  className='mdi mdi-delete font-size-18'
                  id='deletetooltip'
                  onClick={() => this.handleDeleteCategory(cntr)}
                ></i>
              </Link>
            </div>
          )
        }
      ],
    }
    this.toggleCategoryModal = this.toggleCategoryModal.bind(this);
    this.handleNewCategory = this.handleNewCategory.bind(this);
    this.handleEditCategory = this.handleEditCategory.bind(this);
    this.checkExistingCategory = this.checkExistingCategory.bind(this);
    this.handleSubmitCategory = this.handleSubmitCategory.bind(this);
    this.handleDeleteCategory = this.handleDeleteCategory.bind(this)
  }
  toggleCategoryModal = () => { this.setState((prevState) => ({ categoryModal: !prevState.categoryModal })); };
  /**
   * Open modal for new category
   */
  handleNewCategory = () => {
    const { categories } = this.props.props;
    this.setState({ selCategory: [], latestSortNo: categories[categories.length - 1]['sortNo']+1, error: '', isEdit: false });
    this.toggleCategoryModal();
  };
  /**
   * Assign selected category for editing
   * @param {*} category 
   */
  handleEditCategory = (category) => {
    this.setState({
      selCategory: category,
      error: '',
      isEdit: true
    });
    this.toggleCategoryModal();
  };
  /**
   * Check if category is already exists in the table
   * @param {array} newCategory value with new battle invoice No
   * @returns true or false
   */
  checkExistingCategory = (newCategory) => {
    const { categories } = this.props.props;
    return categories.some(function (el) {
      return el.catName === newCategory.catNameLng.catName;
    });
  };
  /**
   * Submit new category row 
   * @param {*} e 
   * @param {*} values 
   */
  handleSubmitCategory = (e, values) => {
    const { onAddInfoData, onEditInfoData, languages } = this.props.props;
    const { isEdit, selCategory, latestSortNo } = this.state;
    console.log(values)

    const catNameLng = {};
    // Always include base English name
    if (values.catName) {
      catNameLng.catName = values.catName;
    }
    // Loop through languages (excluding 'eng' since it's already handled)
    languages.forEach(({ lng_code }) => {
      if (lng_code !== 'eng') {
        const capitalizedCode = lng_code.charAt(0).toUpperCase() + lng_code.slice(1); // e.g. 'ru' → 'Ru'
        const fieldName = `catName${capitalizedCode}`;

        if (values[fieldName]) {
          catNameLng[fieldName] = values[fieldName];
        }
      }
    });

    if (isEdit) {
      const updateCategory = {
        type: 'categories',
        _id: selCategory._id,
        sortNo: parseInt(values.sortNo),
        catNameLng
      };
      console.log(updateCategory)
      onEditInfoData(updateCategory)
      this.toggleCategoryModal();
    } else {
      const newCategory = {
        type: 'categories',
        sortNo: parseInt(values['sortNo']),
        catNameLng
      }
      console.log(newCategory)
      if (this.checkExistingCategory(newCategory) === true) {
        this.setState({
          error: 'Already exists.'
        });
      } else{
        onAddInfoData(newCategory)
        this.toggleCategoryModal();
      }
    }
  };
  /**
   * Display delete alert
   * @param {*} category 
   */
  handleDeleteCategory = (category) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteAlert({type: 'categories', id: category._id, sortNo: category.sortNo })}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Delete category row
   * @param {*} data 
   */
  deleteAlert = (data) => {
    const { onDeleteInfoData } = this.props.props;
    onDeleteInfoData(data);
    this.hideAlert();
  };
  /**
   * Hide alert
   * @returns 
   */
  hideAlert = () => this.setState({ alert: null });
  render() {
    const { SearchBar } = Search;
    const { categories, languages } = this.props.props;
    const { categoryColumns, categoryModal, selCategory, latestSortNo, error, alert, isEdit } = this.state;
    const pageOptions = {
      sizePerPage: categories.length,
      totalSize: categories.length, // replace later with size(users),
      custom: true
    };
    const defaultSorted = [
      {
        dataField: 'sortNo', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];     
    return (
      <React.Fragment>
        <Card>
          <CardBody className='cardBodySticky'>
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField='_id'
              columns={categoryColumns}
              data={categories}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField='_id'
                  columns={categoryColumns}
                  data={categories}
                  search
                >
                  {(toolkitprops) => (
                    <React.Fragment>
                      <Row className='mb-2'>
                        <Col sm='4'>
                          <div className='search-box ms-2 mt-3 mb-2 d-inline-block'>
                            <div className='position-relative'>
                              <SearchBar {...toolkitprops.searchProps} />
                              <i className='bx bx-search-alt search-icon' />
                            </div>
                          </div>
                        </Col>
                        <Col sm='8' className='text-sm-end'>
                          <Button color='primary' className='mt-2 btn-block btn btn-primary btn-lg' onClick={this.handleNewCategory}>
                            <i className='mdi mdi-plus-circle-outline me-1' />
                            Add New Category
                          </Button>
                          <Modal
                            size='m'
                            isOpen={categoryModal}
                            className={this.props.className}
                            toggle={this.toggleCategoryModal}
                          >
                            <ModalHeader toggle={this.toggleCategoryModal} tag='h4'>
                              {!!isEdit ? 'Edit Category' : 'Add Category'}
                            </ModalHeader>
                            <ModalBody>
                              {error !== '' && error ? <Alert color='danger'> {error} </Alert> : null}
                              <AvForm onValidSubmit={this.handleSubmitCategory}>
                                <Row>
                                  <Col md={4}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        name='sortNo'
                                        label='Cat No'
                                        value={selCategory.sortNo || latestSortNo}
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={8}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        name='catName'
                                        label='Cat Name'
                                        value={selCategory.catNameLng?.catName || ''}
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                  {languages.filter(c => c.lng_code !== 'eng').map((language, index) => {
                                    return (
                                      <Col md={12}>
                                        <FormGroup className='mb-3'>
                                          <AvField
                                            name={`catName${language.lng_code.charAt(0).toUpperCase()}${language.lng_code.slice(1)}`}
                                            label={`Category Name ${language.lng_name}`}
                                            value={selCategory.catNameLng?.[`catName${language.lng_code.charAt(0).toUpperCase()}${language.lng_code.slice(1)}`] || ''}
                                            validate={{
                                              required: {
                                                value: true
                                              }
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                    )
                                  })}
                                  {/* <Col md={3}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        name='catNameCn'
                                        label='Cat Name Cn'
                                        value={selCategory.catNameCn || ''}
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={3}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        name='catNameRu'
                                        label='Cat Name Ru'
                                        value={selCategory.catNameRu || ''}
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Col> */}
                                </Row>
                                <Row>
                                  <Col>
                                    <div className='text-end'>
                                      <button
                                        type='submit'
                                        className='btn btn-success save-user'
                                      >
                                        {!!isEdit
                                          ? 'Edit Category'
                                          : 'Add Category'}
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </AvForm>
                            </ModalBody>
                          </Modal>
                        </Col>
                      </Row>
                      <Row id='table-section'>
                        <BootstrapTable
                          {...toolkitprops.baseProps}
                          {...paginationTableProps}
                          defaultSorted={defaultSorted}
                          classes={
                            'table align-middle text-center table-nowrap'
                          }
                          headerClasses='header-class is-sticky-hdr'
                          id='tableScroll'
                          bordered={true}
                          // striped={true}
                          responsive
                        />
                        {alert}
                      </Row>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

CategoriesComp.propTypes = {

};

const mapStateToProps = ({ state }) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CategoriesComp));